<script setup lang="ts">
  import { StatusStateMap } from '@/components/common/StatusIcon/statusIcon';
  import { useI18n } from 'vue-i18n';
  import useCustomerAdmission from '@/composables/useCustomerAdmission';
  import CustomerServiceModal from '@/components/common/CustomerServiceModal/CustomerServiceModal.vue';
  import NotificationBox from '@/components/common/NotificationBox/NotificationBox.vue';

  defineOptions({ name: 'AdmissionStatus' });

  const { isInactive } = useCustomerAdmission();
  const { t } = useI18n();
</script>

<template>
  <NotificationBox
    v-if="isInactive"
    compact
    :title="t('pages.customer.admissionStatus.messageBox.title')"
    :status="StatusStateMap.Error"
  >
    <p>
      {{ t('pages.customer.admissionStatus.messageBox.p1') }}
      {{ t('pages.customer.admissionStatus.messageBox.p2') }}
      <CustomerServiceModal
        :label="t('contactUsPage.linkToSaC')"
        :classes="{
          button: 'min-h-auto'
        }"
      />.
    </p>
  </NotificationBox>
</template>
